export default function createServicesIndex() {
  const client = algoliasearch(process.env.ALGOLIA_ID, process.env.ALGOLIA_CLIENT_SEARCH_API_KEY);
  client.clearCache();
  const index = client.initIndex(process.env.ALGOLIA_SERVICES_INDEX);

  return index;
}
